module.exports = __webpack_public_path__ + "static/media/plane.b8599804.jpg";